import AccommodationGrid from "@/components/AccommodationGrid";
import BookingWidget from "@/components/BookingWidget";
import FAQ from "@/components/FAQ";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { Link } from "react-router-dom";
import { ACCOMMODATIONS } from "@/lib/site";

export default function AccommodationPage() {
  useDocumentMeta();
  return (
    <>
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12" data-testid="accommodation-hero">
        <div className="overline">Stay</div>
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.95] mt-4 max-w-4xl">
          Accommodation in Ballarat <em className="italic font-light">— cabins, caravan sites & camping.</em>
        </h1>
        <p className="mt-6 text-sa-ink2 text-lg max-w-2xl leading-relaxed">
          Six honest, well-built ways to stay in Ballarat. Every option is level, most are shaded, and all are fewer than 90 paces from a hot shower — choose the one that suits how you travel.
        </p>
        <div className="mt-12">
          <BookingWidget overlap={false} />
        </div>
      </section>

      <AccommodationGrid heading={false} />

      {/* Inclusion table */}
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="overline">What's included</div>
        <h2 className="font-serif text-3xl sm:text-4xl tracking-tight mt-4 max-w-2xl">Cabins Ballarat, caravan sites & camping — every stay, no fine print.</h2>
        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {ACCOMMODATIONS.map((a) => (
            <div key={a.id} className="bg-white border border-sa-ink/10 rounded-2xl p-6">
              <div className="font-serif text-xl">{a.name}</div>
              <ul className="mt-4 space-y-2 text-sm text-sa-ink2">
                {a.features.map((f) => (
                  <li key={f} className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-sa-accent" /> {f}
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-6 border-t border-sa-ink/10 flex items-center justify-end">
                <div className="font-serif text-lg">
                  <span className="text-sm font-sans text-sa-ink2 mr-1">from</span>${a.price_from}<span className="text-sm text-sa-ink2 font-sans"> /night</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-12 text-sa-ink2 max-w-3xl text-[15px] leading-relaxed">
          Looking for things to do? Our guests love the bushland walks around{" "}
          <Link to="/" className="text-sa-accent hover:text-sa-accentHover">Sovereign Hill</Link>, the lakeside trail at Lake Wendouree, and the family-friendly{" "}
          <Link to="/amenities" className="text-sa-accent hover:text-sa-accentHover">park amenities</Link>. Have a question first?{" "}
          <Link to="/contact" className="text-sa-accent hover:text-sa-accentHover">Send us an enquiry</Link>.
        </p>
      </section>

      <FAQ />
    </>
  );
}

